<template>
    <div class="toast-body">
        <slot></slot>
    </div>  
</template>
